import { cn } from "@acme/ui";
import { Avatar } from "@acme/ui/avatar";
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from "@acme/ui/tooltip";
import { bottts } from "@dicebear/collection";
import { createAvatar } from "@dicebear/core";
import type { User } from "./Editor/types";

const getPic = (name: string) =>
	`https://api.dicebear.com/9.x/open-peeps/svg?seed=${name}`;

export interface AvatarGroupProps {
	users: User[];
	max?: number;
	className?: string;
}

const getDefaultAvatar = (name: string) => {
	const avatar = createAvatar(bottts, {
		seed: name,
	});

	return avatar.toDataUri();
};

export function AvatarGroup({ users, max = 10, className }: AvatarGroupProps) {
	const visibleUsers = users.slice(0, max);
	const remainingUsers = users.slice(max);

	return (
		<TooltipProvider>
			<div className={cn("flex items-center", className)}>
				{visibleUsers.map((user, index) => (
					<Tooltip key={user.id}>
						<TooltipTrigger>
							<Avatar
								src={user.profilePicture ?? getDefaultAvatar(user.name ?? "")}
								fallback={user.name}
								className={`${index !== 0 ? "-ml-3" : ""} inline-block border-2`}
								style={{
									borderColor: user.color,
									position: "relative",
									zIndex: index + 1,
									...(user.profilePicture
										? {}
										: { backgroundColor: user.color }),
								}}
							/>
						</TooltipTrigger>
						<TooltipContent>{user.name}</TooltipContent>
					</Tooltip>
				))}
				{remainingUsers.length > 0 && (
					<Tooltip>
						<TooltipTrigger asChild>
							<div className="-ml-3 flex h-10 w-10 items-center justify-center rounded-full border-2 border-background bg-muted text-sm font-medium">
								+{remainingUsers.length}
							</div>
						</TooltipTrigger>
						<TooltipContent className="flex gap-2">
							{remainingUsers.map((user, index) => (
								<Avatar
									className="inline-block border-2"
									key={user.name}
									src={user.profilePicture}
									fallback={user.name}
									style={{
										borderColor: user.color,
										position: "relative",
										zIndex: max + index + 1,
										...(user.profilePicture
											? {}
											: { backgroundColor: user.color }),
									}}
								/>
							))}
						</TooltipContent>
					</Tooltip>
				)}
			</div>
		</TooltipProvider>
	);
}
